import {useEffect, useRef, useState} from "react";
import ImageViewer from "components/media/image";
import VideoPlayer from "components/media/video";
import YoutubePlayer from "components/media/youtube";
import {Swiper, SwiperSlide} from "swiper/react";
import styles from "components/sections/palette/contentSection.module.scss";
import ArrowLeftCircle from "images/icons/arrow_left_circle.svg";
import ArrowRightCircle from "images/icons/arrow_right_circle.svg";
import 'swiper/css';
import "swiper/css/pagination";
import "swiper/css/navigation";
import {swiperCustomAnimation} from "common/utils";

let mediaSwiperIndex = {};

export const ContentSection = (props) => {
    const {mediaList, id, mediaSize, autoplay, fullScreen, noControl} = props;

    const onContentView = props.onContentView || function (id) {};

    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const isMobile = true;

    const swiperRef = useRef(null);

    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        if (swiperRef.current) {
            const swiper = swiperRef.current.swiper;
            swiper.allowTouchMove = !!isMobile;
        }
    }, [isMobile]);

    const getMediaComponent = (media, idx) => {
        const height = fullScreen ? '100vh' : `${Math.round(10000 * mediaSize.height / mediaSize.width) / 100}%`;
        switch (media.type) {
            case "image":
                return <ImageViewer item={media} height={height} onContentView={onContentView} isActive={idx === activeIndex} />
            case "video":
                return <VideoPlayer
                    item={media} autoplay={autoplay} isActive={idx === activeIndex}
                    height={height} onContentView={onContentView} noControl={noControl}
                />
            case "youtube":
                return <YoutubePlayer item={media} autoplay={autoplay} isActive={idx === activeIndex} onContentView={onContentView}/>
            default:
                return <div></div>
        }
    }

    const onSlideChange = (swiper) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('PostCardContentSlideChange', {
            activeIndex: swiper.activeIndex,
        });
    };

    return (
        <Swiper
            ref={swiperRef}
            spaceBetween={0}
            onInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
                swiper.params.navigation.disabledClass = styles.disabledNavButton;
                swiper.navigation.init();
                swiper.navigation.update();
            }}
            onSetTranslate={swiperCustomAnimation}
            onActiveIndexChange={(swiper) => {
                setActiveIndex(swiper.activeIndex);
                mediaSwiperIndex[id] = swiper.activeIndex;
            }}
            initialSlide={mediaSwiperIndex[id] || 0}
            allowTouchMove={!!isMobile}
            threshold={0}
            slidesPerView={1}
            pagination={{
                clickable: true,
                horizontalClass: styles.swiperHorizontal,
                bulletClass: styles.swiperBullet,
                bulletActiveClass: styles.swiperBulletActive,
            }}
            onSlideChange={onSlideChange}
        >
            <div ref={prevRef} className={styles.swiperPrevButton} style={{display: isMobile ? 'none' : undefined}}>
                <ArrowLeftCircle viewBox="0 0 24 24" />
            </div>
            <div ref={nextRef} className={styles.swiperNextButton} style={{display: isMobile ? 'none' : undefined}}>
                <ArrowRightCircle viewBox="0 0 24 24" />
            </div>
            {
                mediaList.map((media, i) => {
                    return (
                        <SwiperSlide key={media.id}>
                            {
                                getMediaComponent(media, i)
                            }
                        </SwiperSlide>
                    );
                })
            }
        </Swiper>
    )
};
